import '../App.css';
import 'animate.css';

function ProjectTemplate() {
  return (
    <div className="App">
      <div className="home-container">
        <h1 className="scroll-down-arrow animate__animated animate__fadeInDown animate__slow animate__delay-1s">↓</h1>
        <h5 className="animate__animated animate__fadeIn animate__slow animate__delay-1s">a.mcknight<span className="grey">.digital</span></h5>
        <a href="/">
          <h5 className="animate__animated animate__fadeIn animate__slow animate__delay-1s">← return home</h5>
        </a>
        <h1 className="animate__animated animate__fadeInUp animate__slow">Privacy Policy &amp; Site Licence</h1>
        <p className="animate__animated animate__fadeIn animate__slow animate__delay-2s">Last Updated June 2nd, 2021.</p>
        
        <div className="about animate__animated animate__fadeInUp animate__slower animate__delay-2s">
          <h3>
           Your Agreement with Us
          </h3>
          <h2>
          Your use of the ADAM.MCKNIGHT.DIGITAL website is governed by this agreement (the "Terms"). "[McKnight Digital]" means [McKnight Digital, DBA Adam McKnight]. The "Service" means the services [McKnight Digital] makes available include our web sites ([ADAM.MCKNIGHT.DIGITAL] and [MCKNIGHT.DIGITAL]), our blog, our API, and any other software, sites, and services offered by [McKnight Digitla] in connection to any of those. "Customer Source Code" means any source code you submit to [McKnight Digital] for the purpose of using the Service. "Content" means all content generated by [McKnight Digital] on your behalf (including metric data) and does not include Customer Source Code.

          In order to use the Service, You (the "Customer", "You", or "Your") must first agree to the Terms. You understand and agree that [McKnight Digitla] will treat Your use of the Service as acceptance of the Terms from that point onwards.

          [McKnight Digital] may make changes to the Terms from time to time. You may reject the changes by terminating Your account. You understand and agree that if You use the Service after the date on which the Terms have changed, [McKnight Digital] will treat Your use as acceptance of the updated Terms.

          If you have any question about the Terms, please contact us at [adam@mcknight.digital]. 
          </h2>
        </div>
        <div className="about">
          <h3>
            Your Account:
          </h3>
          <h2>
            <li>You may not use the Service if You are a person barred from receiving the Service under the laws of the United States or other countries, including the country in which You are resident or from which You use the Service.</li>
            <li>You may not use the service unless you are over the age of 13.</li>
            <li>You must be a human. Account created by automated methods are not permitted.</li>
          </h2>
        </div>
        <div className="about">
          <h3>
            Use of Service
          </h3>
          <h2>
           <li>You must provide accurate and complete registration information any time You register to use the Service.</li>
           <li>You are responsible for the security of Your passwords and for any use of Your account.</li>
           <li>Your use of the Service must comply with all applicable laws, regulations and ordinances.</li>
           <li>You agree to not engage in any activity that interferes with or disrupts the Service.</li>
           <li>[McKnight Digital] reserves the right to enforce quotas and usage limits (to any resources, including the API) at its sole discretion, with or without notice, which may result in [COMPANY] disabling or throttling your usage of the Service for any amount of time.</li>
           <li>You may not allow multiple people to use the same account or otherwise access the Service in a manner intended to avoid incurring fees.</li>
          </h2>
        </div>
        <div className="about">
          <h3>
          License from [McKnight Digital] and Restrictions
          </h3>
          <h2>
          [McKnight Digital] gives You a personal, worldwide, royalty-free, non-assignable and non-exclusive license to use the software provided to You by [McKnight Digital] as part of the Service as provided to You by [McKnight Digital]. This license is for the sole purpose of enabling You to use and enjoy the benefit of the Service as provided by [McKnight Digital], in the manner permitted by the Terms.
          <br/>
          You may not (and You may not permit anyone else to): (a) copy, modify, create a derivative work of, reverse engineer, decompile or otherwise attempt to extract the source code of the Service or any part thereof, unless this is expressly permitted or required by law, or unless You have been specifically told that You may do so by [McKnight Digital], in writing (e.g., through an open source software license); or (b) attempt to disable or circumvent any security mechanisms used by the Service.
          <br/>
          Open source software licenses for components of the Service released under an open source license constitute separate written agreements. To the limited extent that the open source software licenses expressly supersede these Terms, the open source licenses govern Your agreement with [McKnight Digital] for the use of the components of the Service released under an open source license.
          </h2>
        </div>
             
      </div>

      
      
    </div>
  );
}

export default ProjectTemplate;
